var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_30",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 130,
    height: 130
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    rx: 14,
    fill: "url(#paint0_linear_1_30)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_30)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-105 102.442L-99.4 91.2554C-96.6 80.0692 -88.2 60.4935 -79.8 54.9004C-71.4 49.3073 -63 60.4935 -51.8 77.2727C-43.4 91.2554 -35 113.628 -26.6 108.035C-18.2 102.442 -9.8 71.6796 -1.4 54.9004C7 38.1211 15.4 38.1211 23.8 46.5108C35 52.1038 43.4 66.0865 51.8 82.8658C60.2 96.8485 68.6 110.831 77 105.238C85.4 99.645 93.8 74.4761 102.2 77.2727C110.6 77.2727 119 108.035 130.2 108.035C138.6 108.035 147 77.2727 155.4 71.6796C163.8 63.29 172.2 77.2727 180.6 82.8658C189 85.6623 197.4 77.2727 205.8 82.8658C217 85.6623 225.4 99.645 233.8 105.238C242.2 110.831 250.6 108.035 253.4 105.238L259 102.442V136H253.4C250.6 136 242.2 136 233.8 136C225.4 136 217 136 205.8 136C197.4 136 189 136 180.6 136C172.2 136 163.8 136 155.4 136C147 136 138.6 136 130.2 136C119 136 110.6 136 102.2 136C93.8 136 85.4 136 77 136C68.6 136 60.2 136 51.8 136C43.4 136 35 136 23.8 136C15.4 136 7 136 -1.4 136C-9.8 136 -18.2 136 -26.6 136C-35 136 -43.4 136 -51.8 136C-63 136 -71.4 136 -79.8 136C-88.2 136 -96.6 136 -99.4 136H-105V102.442Z",
    fill: "#FF8E45"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_30",
    x1: 65,
    y1: 0,
    x2: 65,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF912B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed);
export default __webpack_public_path__ + "static/media/red.420c8bdd.svg";
export { ForwardRef as ReactComponent };